export const cibSparkpost = ["32 32","<path d='M21.599 12c-1.802 1.198-2.401 3.599-2.198 5.198-3-3 4.599-11.396-4-17.198 4.797 7.198-7.401 13-7.401 23.198 0 4 2.599 7.604 8 8.802 5.401-1.198 8-4.802 8-8.802 0-6-3.599-8-2.401-11.198zM16 27.802c-2.401 0-4.599-2-4.599-4.599 0-2.401 2-4.604 4.599-4.604 2.401 0 4.599 2 4.599 4.604-0.198 2.599-2.198 4.599-4.599 4.599z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-sparkpost.js
// module id = null
// module chunks = 